import React from "react";
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import { FaArrowLeft, FaArrowRight, FaTrashAlt, FaUserEdit } from "react-icons/fa";
import moment from 'moment';
import { Link } from 'react-router-dom';
import PortalPagination from '../../components/PortalPagination';
import PortalSpinner from '../../components/Spinner';
import { partnersService } from '../../services/partners';
import { pointService } from '../../services/pointControl';
import { sessionService } from '../../services/session';
import { canAccessPoint, canManagePoint, isFuncionario } from '../../utils/access';
import { getErrorMessage } from '../../utils/errorMessage';
import { filterNamedPartners } from '../../utils/records';

const acesso = Number(sessionStorage.getItem("tipoAcesso") || 0);
const parceiroLogadoId = sessionService.getPartnerId();

class PartnerSchedule extends React.Component {
    state = {
        datatable: [],
        show: false,
        message: '',
        modalShow: false,
        loading: true,
        saving: false,
        entrada: '',
        saida: '',
        dataChegada: '',
        idParceiro: '',
        partnerList: [],
        id: '',
        sala: '',
        currentPage: 1,
        postPerPage: 8
    };

    componentDidMount() {
        this.fetch();
    }

    componentWillUnmount() {
        clearTimeout(this.messageTimer);
    }

    flashMessage = (message) => {
        clearTimeout(this.messageTimer);
        this.setState({ show: true, message });
        this.messageTimer = setTimeout(() => this.setState({ show: false }), 7000);
    };

    showError = (error, fallbackMessage) => {
        this.flashMessage(getErrorMessage(error, fallbackMessage));
    };

    fetch = async () => {
        if (acesso < 1) {
            window.open('/', "_self");
            return;
        }

        try {
            this.setState({ loading: true });
            const currentDay = moment().format('YYYYMMDD');
            const [responsePartner, responseSchedule] = await Promise.all([
                partnersService.getList(),
                pointService.getByDay(currentDay)
            ]);

            this.setState({
                partnerList: filterNamedPartners(responsePartner.data || []),
                dataChegada: moment().format('YYYY-MM-DD'),
                datatable: responseSchedule.data || [],
                currentPage: 1
            });
        } catch (error) {
            this.showError(error, 'Nao foi possivel carregar o ponto de acesso.');
        } finally {
            this.setState({ loading: false });
        }
    };

    refreshDay = async (dataChegada, showLoading = true) => {
        try {
            if (showLoading) {
                this.setState({ loading: true });
            }

            const responseSchedule = await pointService.getByDay(dataChegada);
            this.setState({
                datatable: responseSchedule.data || [],
                currentPage: 1
            });
        } finally {
            if (showLoading) {
                this.setState({ loading: false });
            }
        }
    };

    cancelEdit = () => {
        this.setState({
            modalShow: false,
            entrada: '',
            saida: '',
            idParceiro: isFuncionario(acesso) ? String(parceiroLogadoId) : '',
            sala: '',
            id: '',
            saving: false
        });
    };

    validateFields = () => {
        if (!this.state.entrada) {
            this.flashMessage('Horario de entrada vazio.');
            return false;
        }

        if (!this.state.idParceiro) {
            this.flashMessage('Profissional nao preenchido.');
            return false;
        }

        return true;
    };

    delete = async (id) => {
        try {
            this.setState({ saving: true });
            await pointService.delete(id);
            await this.refreshDay(moment(this.state.dataChegada).format('YYYYMMDD'));
            this.flashMessage('Registro excluido com sucesso.');
            this.setState({ modalShow: false });
        } catch (error) {
            this.showError(error, 'Nao foi possivel excluir o registro.');
        } finally {
            this.setState({ saving: false });
        }
    };

    saveOrUpdate = async () => {
        try {
            if (!this.validateFields()) {
                return;
            }

            const { sala, entrada, saida, dataChegada, id, idParceiro } = this.state;
            const dataAg = moment(dataChegada).format('YYYYMMDD');
            const body = {
                dataChegada: dataAg,
                sala,
                entrada,
                saida,
                idParceiro: isFuncionario(acesso) ? parceiroLogadoId : idParceiro
            };

            this.setState({ saving: true });

            if (id) {
                await pointService.patch(body, id);
            } else {
                await pointService.post(body);
            }

            await this.refreshDay(dataAg);
            this.flashMessage(`Registro ${id ? 'atualizado' : 'inserido'} com sucesso.`);
            this.cancelEdit();
        } catch (error) {
            this.showError(error, 'Nao foi possivel salvar o registro.');
            this.setState({ saving: false });
        }
    };

    returnPartnerName = (id) => {
        const response = this.state.partnerList.find((item) => Number(item.idUsuario) === Number(id));
        return response ? `${response.Nome} ${response.Sobrenome}`.trim() : 'Nao identificado';
    };

    editModal = async (id) => {
        try {
            if (id) {
                this.setState({ saving: false });
                const { data } = await pointService.getById(id);
                const item = data && data[0];

                if (!item) {
                    this.flashMessage('Registro nao encontrado.');
                    return;
                }

                this.setState({
                    ...item,
                    id,
                    modalShow: true
                });
                return;
            }

            this.setState({
                id: '',
                idParceiro: isFuncionario(acesso) ? String(parceiroLogadoId) : '',
                entrada: '',
                saida: '',
                sala: '',
                modalShow: true
            });
        } catch (error) {
            this.showError(error, 'Nao foi possivel abrir o registro.');
        }
    };

    nextDay = async () => {
        try {
            const nextDate = moment(this.state.dataChegada).add(1, 'd');
            await this.refreshDay(nextDate.format('YYYYMMDD'));
            this.setState({ dataChegada: nextDate.format('YYYY-MM-DD') });
        } catch (error) {
            this.showError(error, 'Nao foi possivel carregar o proximo dia.');
        }
    };

    prevDay = async () => {
        try {
            const prevDate = moment(this.state.dataChegada).add(-1, 'd');
            await this.refreshDay(prevDate.format('YYYYMMDD'));
            this.setState({ dataChegada: prevDate.format('YYYY-MM-DD') });
        } catch (error) {
            this.showError(error, 'Nao foi possivel carregar o dia anterior.');
        }
    };

    setDay = async (dataChegada) => {
        try {
            await this.refreshDay(moment(dataChegada).format('YYYYMMDD'));
            this.setState({ dataChegada });
        } catch (error) {
            this.showError(error, 'Nao foi possivel carregar a data selecionada.');
        }
    };

    render() {
        const { datatable, currentPage, postPerPage, idParceiro, loading, saving } = this.state;
        const totalPages = Math.max(1, Math.ceil(datatable.length / postPerPage));
        const safePage = Math.min(Math.max(currentPage, 1), totalPages);
        const currentData = datatable.slice((safePage - 1) * postPerPage, safePage * postPerPage);
        const parceiroLogado = this.state.partnerList.find((item) => Number(item.idUsuario) === Number(parceiroLogadoId));
        const completedPoints = datatable.filter((item) => item.saida).length;
        const pendingPoints = Math.max(datatable.length - completedPoints, 0);

        return (
            <Container fluid className="portal-shell">
                <div className="portal-alert">
                    <Alert show={this.state.show} variant="info" dismissible onClose={() => this.setState({ show: false })}>
                        {this.state.message}
                    </Alert>
                </div>

                <div className="page-header">
                    <div>
                        <h2 className="page-title">Ponto de acesso</h2>
                        <p className="page-subtitle">
                            {isFuncionario(acesso)
                                ? 'Registre sua entrada e saida em um fluxo mais claro e rapido.'
                                : 'Acompanhe a operacao do dia, salas utilizadas e registros pendentes da equipe.'}
                        </p>
                    </div>
                </div>

                <div className="portal-page-grid">
                    <div className="portal-page-main">
                        <div className="portal-card portal-section">
                            <div className="portal-card-header">
                                <div className="portal-card-copy">
                                    <span className="portal-card-kicker">Controle diario</span>
                                    <h3 className="portal-card-title">Registros de ponto</h3>
                                    <p className="portal-card-subtitle">
                                        Visualize rapidamente quem entrou, quem saiu e ajuste o registro quando o perfil permitir.
                                    </p>
                                </div>
                                <div className="portal-table-actions">
                                    <Button as={Link} variant="secondary" to="/">
                                        Voltar
                                    </Button>
                                    {canAccessPoint(acesso) ? (
                                        <Button variant="success" onClick={() => this.editModal()}>
                                            Adicionar
                                        </Button>
                                    ) : null}
                                </div>
                            </div>

                            <div className="portal-date-nav">
                                <Button disabled={loading} variant="primary" onClick={this.prevDay}>
                                    <FaArrowLeft />
                                </Button>
                                <Form.Control
                                    disabled={loading}
                                    value={this.state.dataChegada}
                                    type="date"
                                    onChange={item => this.setDay(item.target.value)}
                                />
                                <Button disabled={loading} variant="primary" onClick={this.nextDay}>
                                    <FaArrowRight />
                                </Button>
                            </div>

                            {loading ? (
                                <PortalSpinner
                                    block
                                    label="Carregando registros"
                                    description="Buscando marcacoes de entrada e saida da data selecionada."
                                />
                            ) : (
                                <>
                                    <div className="portal-table-wrap">
                                        <div className="portal-table-viewport">
                                            <Table responsive className="portal-table">
                                                <thead>
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Profissional</th>
                                                        <th>Sala</th>
                                                        <th>Entrada</th>
                                                        <th>Saida</th>
                                                        <th>Acoes</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {currentData.length ? currentData.map((item) => (
                                                        <tr key={item.id}>
                                                            <td className="portal-data-strong">{item.id}</td>
                                                            <td>{this.returnPartnerName(item.idParceiro)}</td>
                                                            <td>{item.sala || '-'}</td>
                                                            <td>{item.entrada || '--:--'}</td>
                                                            <td>{item.saida || '--:--'}</td>
                                                            <td>
                                                                <div className="portal-actions">
                                                                    {canAccessPoint(acesso) ? (
                                                                        <Button disabled={saving} variant="link" onClick={() => this.editModal(item.id)}>
                                                                            <FaUserEdit />
                                                                        </Button>
                                                                    ) : null}
                                                                    {canManagePoint(acesso) ? (
                                                                        <Button disabled={saving} variant="link" onClick={() => this.delete(item.id)}>
                                                                            <FaTrashAlt />
                                                                        </Button>
                                                                    ) : null}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="6">
                                                                <div className="portal-empty-state">Nenhum registro encontrado para esta data.</div>
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </div>

                                    <div className="portal-pagination">
                                        <PortalPagination
                                            currentPage={safePage}
                                            onPageChange={(pageNumber) => this.setState({ currentPage: pageNumber })}
                                            totalPages={totalPages}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="portal-page-side">
                        <div className="portal-card portal-section">
                            <span className="portal-card-kicker">Resumo do dia</span>
                            <div className="portal-overview-grid">
                                <div className="portal-overview-item">
                                    <strong>{loading ? '--' : datatable.length}</strong>
                                    <span>registros carregados</span>
                                </div>
                                <div className="portal-overview-item">
                                    <strong>{loading ? '--' : completedPoints}</strong>
                                    <span>saidas ja registradas</span>
                                </div>
                            </div>
                        </div>

                        <div className="portal-card portal-section">
                            <span className="portal-card-kicker">Operacao</span>
                            <div className="portal-note-list">
                                <div className="portal-note">
                                    <strong>{loading ? '--' : pendingPoints} em aberto</strong>
                                    <span>Entradas sem saida registrada para a data selecionada.</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal className="portal-modal" show={this.state.modalShow} onHide={this.cancelEdit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Registro de ponto</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="portal-form-grid">
                            {isFuncionario(acesso) ? (
                                <Form.Group>
                                    <Form.Label>Profissional</Form.Label>
                                    <Form.Control
                                        readOnly
                                        value={parceiroLogado ? `${parceiroLogado.Nome} ${parceiroLogado.Sobrenome}` : sessionService.getDisplayName()}
                                    />
                                </Form.Group>
                            ) : (
                                <Form.Group>
                                    <Form.Label>Profissional</Form.Label>
                                    <Form.Select
                                        disabled={saving}
                                        value={idParceiro}
                                        onChange={(event) => this.setState({ idParceiro: event.target.value })}
                                    >
                                        <option value="">Selecione</option>
                                        {this.state.partnerList.map((partner) => (
                                            <option key={partner.idUsuario} value={partner.idUsuario}>
                                                {`${partner.Nome} ${partner.Sobrenome}`}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            )}

                            <div className="portal-form-grid two-columns">
                                <Form.Group>
                                    <Form.Label>Entrada</Form.Label>
                                    <Form.Control
                                        disabled={saving}
                                        value={this.state.entrada}
                                        type="time"
                                        onChange={item => this.setState({ entrada: item.target.value })}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <Form.Label>Saida</Form.Label>
                                    <Form.Control
                                        disabled={saving}
                                        value={this.state.saida}
                                        type="time"
                                        onChange={item => this.setState({ saida: item.target.value })}
                                    />
                                </Form.Group>
                            </div>

                            <Form.Group>
                                <Form.Label>Sala</Form.Label>
                                <Form.Control
                                    disabled={saving}
                                    value={this.state.sala}
                                    placeholder="Sala"
                                    onChange={item => this.setState({ sala: item.target.value })}
                                />
                            </Form.Group>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={saving} variant="secondary" onClick={this.cancelEdit}>
                            Fechar
                        </Button>
                        <Button disabled={saving} variant="success" onClick={this.saveOrUpdate}>
                            {saving ? 'Salvando...' : 'Salvar'}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </Container>
        );
    }
}

export default PartnerSchedule;
